import { SSOAuthProvider } from 'entities/sso';

// TODO: consider moving to pageConfig.json on CDN
export const ssoAuthProviders: SSOAuthProvider[] = [
  {
    key: 'GOOGLE',
    isActive: true,
    imagePath: `/assets/logos/google-logo-white.svg`,
    imagePathMobile: `/assets/logos/google-logo.svg`,
    text: {
      eng: {
        login: 'Log in with Google',
        signup: 'Sign up with Google',
      },
      deu: {
        login: 'Einloggen mit Google',
        signup: 'Anmelden mit Google',
      },
    },
    colors: {
      text: '#fff',
      background: '#000',
      mobileText: '#000',
      mobileBackground: '#FFF',
    },
    supportedPlatforms: ['ios', 'android'],
  },
  {
    key: 'APPLE',
    isActive: true,
    imagePath: `/assets/logos/apple-logo-white.svg`,
    imagePathMobile: `/assets/logos/apple-logo-white.svg`,
    text: {
      eng: {
        login: 'Log in with Apple',
        signup: 'Sign up with Apple',
      },
      deu: {
        login: 'Einloggen mit Apple',
        signup: 'Anmelden mit Apple',
      },
    },
    colors: {
      text: '#fff',
      background: '#000',
      mobileText: '#fff',
      mobileBackground: '#000',
    },
    supportedPlatforms: ['ios', 'android'],
  },
];

export default ssoAuthProviders;
